import React, { Fragment } from 'react';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import Hero2 from '../../components/hero2/Hero2';
import RegisterSection from '../../components/RegisterSection/RegisterSection';
import ServiceSection2 from '../../components/ServiceSection2/ServiceSection2';
import GetQuateSection from '../../components/GetQuateSection/GetQuateSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import EventSectionS2 from '../../components/EventSectionS2/EventSectionS2';
import PrayerSectionS2 from '../../components/PrayerSectionS2/PrayerSectionS2';
import BlogSectionS2 from '../../components/BlogSectionS2/BlogSectionS2';
import CtaSectionS3 from '../../components/CtaSectionS3/CtaSectionS3';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'

const HomePage2 = () => {
    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
            <Hero2 />
            <PrayerSectionS2 hclass={'project-section-s2 section-padding'} />
            <RegisterSection />
            <ServiceSection2 hclass={'service-section-s2 section-padding'} />
            <GetQuateSection hclass={'GetQuate-section section-padding'} />
            <TeamSection hclass={'volunteer-section section-padding'} />
            <EventSectionS2 hclass={'project-section-s2 section-padding'} />
            <BlogSectionS2 tClass={'blog-section-s2'} />
            <CtaSectionS3 />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;